/* Equaliv — controlador partilhado dos formulários de produto (PDP, barra fixa, quick add). Delegação no document. */
(() => {
  if (window.EQPF) return;
  const EQPF = (window.EQPF = {});
  const money = (c) => (window.EQ && EQ.money ? EQ.money(c) : 'R$ ' + (c / 100).toFixed(2).replace('.', ','));
  const inst = (c) => (window.EQ && EQ.installments ? EQ.installments(c) : '');
  const data = (form) => {
    if (form._eqd === undefined) {
      const s = form.querySelector('[data-eq-product-json]');
      try { form._eqd = JSON.parse(s.textContent); } catch (_) { form._eqd = null; }
    }
    return form._eqd;
  };
  const idInput = (form) => form.querySelector('[name="id"]');
  const current = (form) => {
    const d = data(form);
    const id = Number(idInput(form) && idInput(form).value);
    return d && (d.variants.find((x) => x.id === id) || d.variants[0]);
  };
  const qtyOf = (form) => Math.max(1, Number((form.querySelector('[name="quantity"]') || {}).value || 1));
  const tierPct = (d, n) => (d.tiers || []).reduce((p, t) => (Number(t.qtd) <= n && Number(t.pct) > p ? Number(t.pct) : p), 0);
  const setText = (root, sel, txt) => root.querySelectorAll(sel).forEach((el) => (el.textContent = txt));

  EQPF.variant = current;
  EQPF.render = (form) => {
    const d = data(form);
    const v = current(form);
    if (!d || !v) return;
    const q = qtyOf(form);
    setText(form, '[data-eq-price]', money(v.price));
    form.querySelectorAll('[data-eq-compare-wrap]').forEach((el) => (el.hidden = !(v.compare > v.price)));
    if (v.compare > v.price) {
      setText(form, '[data-eq-compare]', money(v.compare));
      setText(form, '[data-eq-off]', '-' + Math.floor(((v.compare - v.price) * 100) / v.compare) + '%');
    }
    const i = inst(v.price);
    setText(form, '[data-eq-inst]', i);
    setText(form, '[data-eq-inst-short]', i.replace(/^ou\s+/i, '').replace(/\s+sem juros$/i, ''));
    form.querySelectorAll('[data-eq-lowstock]').forEach((el) => (el.hidden = !(v.available && v.inv !== null && v.inv > 0 && v.inv <= (d.lowStock || 5))));
    form.querySelectorAll('[data-eq-add]').forEach((b) => {
      b.disabled = !v.available;
      const l = b.querySelector('[data-eq-add-label]');
      const lm = b.querySelector('[data-eq-add-label-m]');
      if (l) l.textContent = v.available ? b.dataset.label : b.dataset.soldout;
      if (lm) lm.textContent = v.available ? b.dataset.labelMobile : b.dataset.soldout;
    });
    const full1 = Math.max(v.compare || 0, v.price);
    form.querySelectorAll('[data-eq-tier-qty]').forEach((c) => {
      const n = Number(c.dataset.eqTierQty);
      const pct = tierPct(d, n);
      const total = Math.round((v.price * n * (100 - pct)) / 100);
      const full = full1 * n;
      const t = c.querySelector('[data-eq-tier-total]');
      const f = c.querySelector('[data-eq-tier-full]');
      if (t) t.textContent = money(total);
      if (f) { f.textContent = money(full); f.hidden = !(full > total); }
    });
    let best = null;
    form.querySelectorAll('[data-eq-tier-qty]').forEach((c) => { if (Number(c.dataset.eqTierQty) <= q) best = c; });
    form.querySelectorAll('[data-eq-tier-qty]').forEach((c) => {
      const on = c === best && Number(c.dataset.eqTierQty) === q;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.dispatchEvent(new CustomEvent('eq:variant:change', { detail: { form, variant: v, product: d, quantity: q } }));
  };

  const selectVariantFromChips = (form, clicked) => {
    const d = data(form);
    if (!d) return;
    const vals = [...form.querySelectorAll('[data-eq-opt].is-active')].map((b) => b.dataset.value);
    let v = d.variants.find((x) => vals.every((val) => x.options.includes(val)));
    if (!v && clicked) v = d.variants.find((x) => x.options.includes(clicked.dataset.value) && x.available) || d.variants.find((x) => x.options.includes(clicked.dataset.value));
    if (!v) return;
    idInput(form).value = v.id;
    form.querySelectorAll('[data-eq-opt]').forEach((b) => {
      const on = v.options.includes(b.dataset.value);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    if (form.dataset.updateUrl) {
      const u = new URL(location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', u.toString());
    }
    EQPF.render(form);
    if (v.media) document.dispatchEvent(new CustomEvent('eq:media:show', { detail: { form, media: v.media } }));
  };
  EQPF.selectValue = (form, value) => {
    const b = [...form.querySelectorAll('[data-eq-opt]')].find((x) => x.dataset.value === value);
    if (b) b.click();
  };
  EQPF.setQty = (form, n) => {
    const input = form.querySelector('[name="quantity"]');
    if (!input) return;
    input.value = Math.max(1, Math.min(99, Number(n) || 1));
    EQPF.render(form);
  };

  document.addEventListener('click', (e) => {
    const opt = e.target.closest('form[data-eq-pf] [data-eq-opt]');
    if (opt) {
      e.preventDefault();
      const form = opt.closest('form');
      const group = opt.closest('[data-eq-opt-group]') || form;
      group.querySelectorAll('[data-eq-opt]').forEach((b) => b.classList.toggle('is-active', b === opt));
      selectVariantFromChips(form, opt);
      return;
    }
    const sib = e.target.closest('[data-eq-quick-content] [data-eq-sibling]');
    if (sib && window.EQ && EQ.quickAdd) {
      e.preventDefault();
      if (!sib.classList.contains('is-active')) EQ.quickAdd(sib.dataset.eqSibling);
      return;
    }
    const tier = e.target.closest('form[data-eq-pf] [data-eq-tier-qty]');
    if (tier) {
      e.preventDefault();
      EQPF.setQty(tier.closest('form'), tier.dataset.eqTierQty);
    }
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches && e.target.matches('form[data-eq-pf] [name="quantity"]')) EQPF.render(e.target.closest('form'));
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest && e.target.closest('form[data-eq-pf]');
    if (!form) return;
    e.preventDefault();
    const b = form.querySelector('[data-eq-add]');
    if (b && !b.disabled) b.click();
  });
  /* quick add: fecha ao abrir o carrinho; inicializa o conteúdo injetado */
  document.addEventListener('eq:cart:open', () => {
    const qa = document.getElementById('EqQuickAdd');
    if (qa && qa.classList.contains('is-open') && window.EQ) EQ.close('EqQuickAdd');
  });
  const initQuick = () => {
    const host = document.getElementById('EqQuickAdd');
    if (!host || host._eqObs) return;
    host._eqObs = new MutationObserver(() => host.querySelectorAll('form[data-eq-pf]').forEach((f) => { if (!f._eqInit) { f._eqInit = 1; EQPF.render(f); } }));
    host._eqObs.observe(host, { childList: true, subtree: true });
  };
  /* barra de frete grátis */
  const paintShip = (cart) => {
    document.querySelectorAll('[data-eq-shipbar]').forEach((bar) => {
      const goal = Number(bar.dataset.goal || 0);
      if (!goal) return;
      const total = Number(cart.total_price || 0);
      const miss = goal - total;
      const txt = bar.querySelector('[data-eq-shipbar-text]');
      if (txt) txt.innerHTML = miss > 0 ? bar.dataset.missing.replace('[valor]', '<strong>' + money(miss) + '</strong>') : bar.dataset.reached;
      const m = bar.querySelector('[data-eq-shipbar-meter]');
      if (m) m.style.setProperty('--p', Math.min(100, Math.round((total * 100) / goal)) + '%');
    });
  };
  document.addEventListener('eq:cart:updated', (e) => e.detail && paintShip(e.detail));
  const boot = () => {
    document.querySelectorAll('form[data-eq-pf]').forEach((f) => { f._eqInit = 1; EQPF.render(f); });
    initQuick();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', boot);
})();
